import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class AccountBillingDetailsService {
    static getPolicyBillingSummary(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('billingData'),
            'getPolicyBillingSummary',
            [policyNumber],
            additionalHeaders
        );
    }
}
